'use client'

import * as React from 'react'

import CssBaseline from '@mui/material/CssBaseline'

// Configure MUI for server-side rendering
if (typeof window !== 'undefined') {
  // Client-side only code
}

interface MuiRegistryProps {
  children: React.ReactNode
}

export default function MuiRegistry({ children }: MuiRegistryProps) {
  // Remove ThemeProvider here as it's handled by the custom ThemeProvider
  // This prevents theme conflicts and ensures our custom theme is used
  return (
    <>
      <CssBaseline />
      {children}
    </>
  )
}

// Named export for compatibility
export { MuiRegistry }
